import { render, staticRenderFns } from "./left-slider.vue?vue&type=template&id=4ec98024&scoped=true&"
import script from "./left-slider.vue?vue&type=script&lang=js&"
export * from "./left-slider.vue?vue&type=script&lang=js&"
import style0 from "./left-slider.vue?vue&type=style&index=0&id=4ec98024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec98024",
  null
  
)

component.options.__file = "left-slider.vue"
export default component.exports